export const PRINTER_FIELDS = [{
    type: 'text',
    name: 'printerId',
    label: '_id_',
    inputType: 0,
    required: true,
    disabled: false,
    validations: {
        minLength: 4
    },
    validationError: '',
    validationErrors: {
        isDefaultRequiredValue: '_required_field_',
        minLength: '_partner_min_4_error_'
    }
}, {
    type: 'text',
    name: 'name',
    label: '_name_',
    inputType: 0,
    required: true,
    disabled: false,
    validations: {
        minLength: 4
    },
    validationError: '',
    validationErrors: {
        isDefaultRequiredValue: '_required_field_',
        minLength: '_partner_min_4_error_'
    }
}, {
    type: 'text',
    name: 'userName',
    label: '_username_',
    inputType: 0,
    required: true,
    disabled: false,
    validations: {
        minLength: 4
    },
    validationError: '',
    validationErrors: {
        isDefaultRequiredValue: '_required_field_',
        minLength: '_partner_min_4_error_'
    }
}, {
    type: 'text',
    name: 'password',
    label: '_password_',
    inputType: 0,
    required: true,
    disabled: false,
    validations: {
        minLength: 6
    },
    validationError: '',
    validationErrors: {
        isDefaultRequiredValue: '_required_field_',
        minLength: '_partner_min_6_error_'
    }
}, {
    type: 'text',
    name: 'partner',
    label: '_partner_',
    inputType: 0,
    required: false,
    disabled: false,
    validations: {},
    validationError: '',
    validationErrors: {
    }
}, {
    type: 'text',
    name: 'branch',
    label: '_branch_',
    inputType: 0,
    required: false,
    disabled: false,
    validations: {},
    validationError: '',
    validationErrors: {
    }
}, {
    type: 'boolean',
    name: 'active',
    label: '_active_',
    inputType: 0,
    required: false,
    disabled: false,
    validations: {},
    validationError: '',
    validationErrors: {
    }
}];